import { useId } from "react";

const MonfiMarkIcon = ({ className = "h-10 w-10" }) => {
  const greenGradientId = useId();
  const blueGradientId = useId();

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 63 64"
      fill="none"
      className={`drop-shadow-[0_4px_4px_rgba(0,0,0,0.25)] ${className}`}
      aria-hidden
    >
      <path
        d="M30.4878 9.89276C16.6349 18.292 2.90373 33.79 0.0142232 62.4131C0.0142232 62.4558 0 62.4958 0 62.5366H0.0142232H0.17865C1.64518 46.6262 15.0315 34.1865 31.3099 34.1865C47.3964 34.1865 60.6467 46.3266 62.3718 61.9607C62.4012 62.0842 62.4145 62.1936 62.4145 62.3038C62.4554 62.6726 62.4811 63.0299 62.4954 63.3854C62.5105 63.3997 62.5238 63.3997 62.5372 63.4121V0.00038147C62.5372 0.00038147 46.424 0.246571 30.4878 9.89276Z"
        fill={`url(#${blueGradientId})`}
      />
      <path
        opacity="0.9"
        transform="translate(0, 1.5)"
        d="M0 63.4277C0.0142209 63.4126 0.0275498 63.3993 0.0551027 63.3851C0.0666572 62.7958 0.109321 62.2207 0.164427 61.6315C1.63095 45.721 15.0172 33.2813 31.2957 33.2813C47.2773 33.2813 60.4591 45.2624 62.3221 60.7507C58.9677 32.1312 44.578 17.0019 30.4735 8.98758C15.0723 0.231083 0 -3.8147e-06 0 -3.8147e-06V63.4277Z"
        fill={`url(#${greenGradientId})`}
      />
      <defs>
        <linearGradient
          id={blueGradientId}
          x1="62.5377"
          y1="31.7063"
          x2="0.000603856"
          y2="31.7063"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#005AB4" />
          <stop offset="0.00666528" stopColor="#005AB4" />
          <stop offset="1" stopColor="#0CB9F1" />
        </linearGradient>
        <linearGradient
          id={greenGradientId}
          x1="8.6214e-05"
          y1="31.7136"
          x2="62.3577"
          y2="31.7136"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#45AE1B" />
          <stop offset="0.999669" stopColor="#5DCE27" />
          <stop offset="0.999999" stopColor="#5DCE27" />
          <stop offset="1" stopColor="#5DCE27" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default MonfiMarkIcon;
